import { useEffect } from "react";
import Lenis from "lenis";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Products } from "@/components/landing/Products";
import { Quality } from "@/components/landing/Quality";
import { LabReports } from "@/components/landing/LabReports";
import { Footer } from "@/components/landing/Footer";
import { CartDrawer } from "@/components/landing/CartDrawer";
import { AuthModal } from "@/components/landing/AuthModal";
import { LiveOrders } from "@/components/landing/LiveOrders";

export default function Landing() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <div data-testid="landing-page" className="bg-[#FBFBFC] text-[#09090B] min-h-screen">
          <div className="noise-overlay" />
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Products />
            <Quality />
            <LabReports />
          </main>
          <Footer />
          <CartDrawer />
          <AuthModal />
          <LiveOrders />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}
